import { useSelector } from 'react-redux';
import { ApplicationState } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Banner } from '@optimus-web/core';
import { getResourceCategoryName } from '@mews-commander/legacy-entities/src/ducks/resourceCategories';

interface Props {
    assignedCategoryId: string;
    selectedCategoryId: string;
    serviceId: string;
}

export const AvailabilityBlockResourceCategoriesBanner = ({
    assignedCategoryId,
    selectedCategoryId,
    serviceId,
}: Props) => {
    const newResourceCategoryName =
        useSelector((state: ApplicationState) =>
            getResourceCategoryName(state, { id: selectedCategoryId, serviceId })
        ) || '';
    const oldResourceCategoryName =
        useSelector((state: ApplicationState) =>
            getResourceCategoryName(state, { id: assignedCategoryId, serviceId })
        ) || '';

    return (
        <Banner
            variant="warning"
            primaryText={
                <LocalizedText
                    textKey={TextKey.ResourceCategoryNotInAvailabilityBlockTitle}
                    substitutes={{ resourceCategoryName: newResourceCategoryName }}
                />
            }
            secondaryText={
                <LocalizedText
                    textKey={TextKey.ResourceCategoryNotInAvailabilityBlockMessage}
                    substitutes={{ oldResourceCategoryName, newResourceCategoryName }}
                />
            }
        />
    );
};
